import React, { Component } from 'react';
import _ from 'lodash';
import {
    getPayoutBatches as fetchPayoutBatches,
    fetchUrl
} from './payoutBatchesActions';
import {
    getPayoutBatches,
    getCount,
    getPages,
    getPayoutBatchesErrorMessage,
    getIsPayoutBatchesLoading,
    getHasMore
} from './payoutBatchesEntity';
import { transformDateCell } from '../../utils/cell';
import Table from '../Table/Table';
import { dataTransform } from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import { selectPayoutBatch } from './payoutBatchesActions';
import { getSelectedPayoutAccountIdsString } from '../PayoutAccountSelector/payoutAccountSelectorViewState';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';
import { getColumnsByUniqueTableName } from '../Table/tableEntity';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getCustomAccess } from '../Self/selfEntity';
import { toggleModal } from '../Modal/modalActions';
import { getIsUserAnAdmin } from '../UserData/userDataEntity';
import PayoutBatchStatusFilter from '../Table/Filters/PayoutBatchStatusFilter/PayoutBatchStatusFilter';
import PayoutBatchListItem from './PayoutBatchListItem/PayoutBatchListItem';
import './PayoutBatches.scss';
import FilterWithMapper from '../Table/Filters/FilterWithMapper/FilterWithMapper';

export class PayoutBatches extends Component {
    dateKey = 'updatedAt';

    static propTypes = {
        selectedPayoutAccountIds: PropTypes.string,
        onToggleModal: PropTypes.func.isRequired,
        columns: PropTypes.array,
        payoutAccountMap: PropTypes.any,
        timezone: PropTypes.string,
        customAccess: PropTypes.any,
        isAdmin: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.defaultColumnsAndProps = [
            {
                accessor: 'payoutAccountId',
                transformData: (data) => `${data.original.payoutAccountId} - ${this.props.payoutAccountMap[data.original.payoutAccountId]}`,
                filterable: true,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper filter={filter}
                        mapper={this.getPayoutAccountsDropDown()}
                        onChange={onChange}
                    />
                ),
                className: ['cursor-pointer'],
                label: 'Payout Account',
                minWidth: 200,
                show: true,
                sortable: true
            },
            {
                accessor: 'batchRef',
                className: ['cursor-pointer'],
                label: 'Batch Ref',
                minWidth: 250,
                show: true,
                filterable: true,
                sortable: true
            },
            {
                accessor: 'initialBatchDate',
                Cell: transformDateCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Initial Batch Date',
                minWidth: 185,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'updatedAt',
                Cell: transformDateCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Last Updated At',
                minWidth: 185,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'batchProcessingStatus',
                filterable: true,
                Filter: ({ filter, onChange }) => (
                    <PayoutBatchStatusFilter filter={filter} onChange={onChange} />
                ),
                className: ['cursor-pointer'],
                label: 'Batch Processing Status',
                minWidth: 175,
                show: true,
                sortable: true
            },
            {
                accessor: 'payoutCount',
                className: ['cursor-pointer'],
                label: 'Payout Count',
                minWidth: 105,
                show: true,
                filterable: false,
                sortable: false
            },
            {
                accessor: 'processedPayoutCount',
                className: ['cursor-pointer'],
                label: 'Processed Payout Count',
                minWidth: 180,
                show: true,
                filterable: false,
                sortable: false
            },
            {
                accessor: 'failedPayoutCount',
                className: ['cursor-pointer'],
                label: 'Failed Payout Count',
                minWidth: 150,
                show: true,
                filterable: false,
                sortable: false
            },
            {
                accessor: 'badPayoutRequestCount',
                className: ['cursor-pointer'],
                label: 'Errored Payout Count',
                minWidth: 200,
                show: true,
                filterable: false,
                sortable: false
            }
        ];
    }

    renderHeaderComponent = () => {
        return (
            <div className="payout-table-header">
                {this.props.isAdmin ? <span className="material-icons" title="Upload Payout Batch" onClick={() => this.props.onToggleModal('uploadPayouts')}>upload_file</span> : null}
            </div>
        );
    };

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    getPayoutAccountsDropDown = () => {
        const result = {};
        _.forEach(this.props.payoutAccountMap, (value, key) => {
            result[key] = `${key} - ${value}`;
        });

        return result;
    };

    render() {
        return (
            <div className="emvio-payout-batches">
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-payout-batches-table"
                    dateKey={this.dateKey}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: this.dateKey
                    }]}
                    fetchData={(filters, page, pageSize, sorters, merchantIds, columns) => fetchPayoutBatches(filters, page, pageSize, sorters, this.props.selectedPayoutAccountIds, columns)}
                    countSelector={getCount}
                    dataSelector={getPayoutBatches}
                    selectRow={selectPayoutBatch}
                    errorMessageSelector={getPayoutBatchesErrorMessage}
                    isDataLoadingSelector={getIsPayoutBatchesLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    HeaderComponent={this.renderHeaderComponent}
                    hasMoreSelector={getHasMore}
                    ListItemComponent={PayoutBatchListItem}
                    noDataText="No Payout Batches Found"
                    uniqueTableName="PayoutBatches"
                    getTableState={this.getTableState}
                    filterable={true}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPayoutAccountIds: getSelectedPayoutAccountIdsString(state),
        columns: getColumnsByUniqueTableName(state, 'PayoutBatches'),
        payoutAccountMap: getPayoutAccountsMapper(state),
        customAccess: getCustomAccess(state),
        isAdmin: getIsUserAnAdmin(state)
    };
}

function mapDispatchToProps(dispatch) {
    return { onToggleModal: () => dispatch(toggleModal('uploadPayouts')) };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PayoutBatches));
